<template>
  <div id="sideBarItem">
    <li @click="change" :class="isActive">
      <svg class="icon" aria-hidden="true">
        <use v-bind:xlink:href="svgHref"></use>
      </svg>
      <span class="word">{{ todoWord }}</span>
    </li>
  </div>
</template>

<script>
export default {
  name: "SideBarItem",
  props: {
    svgHref: String,
    todoWord: String,
    path: String,
  },
  methods: {
    change() {
      this.$router.push(this.path);
    },
  },
  computed: {
    isActive() {
      return this.$route.path.indexOf(this.path) !== -1 ? "active" : "";
    },
  },
};
</script>

<style scoped lang="less">
//字体图标
.icon {
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.3em;
  fill: currentColor;
  overflow: hidden;
}
li {
  padding-left: 0.2375rem;
  height: 0.2875rem;
  line-height: 0.2875rem;
  cursor: pointer;
  &:hover {
    background-color: @active-bgc;
  }
  .word {
    color: @color-text;
    text-decoration: none;
    padding-left: 0.0625rem;
    display: inline-block;
  }
}
.active {
  background-color: @active-bgc;
  .word {
    color: @main-col;
  }
}

// :root[data-theme="dark"] {
//   li {
//     &:hover {
//       background-color: @color-text;
//     }
//   }
//   .active {
//     background-color: @color-text;
//     .word {
//       color: @main-col;
//     }
//   }
// }
</style>